// @ts-ignore - allow import with query string
import { fetchModalContent } from './util.js?v=25';

function handleDeviceChange() {
  function getDevice() {
    return window.innerWidth < 992 ? 'mobile' : 'desktop';
  }

  let lastDevice = getDevice();

  window.addEventListener('resize', () => {
    const currentDevice = getDevice();

    if (currentDevice !== lastDevice) {
      lastDevice = currentDevice;

      document.dispatchEvent(
        new CustomEvent('deviceChanged', {
          detail: {
            device: currentDevice,
          },
        }),
      );
    }
  });
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  // @ts-ignore
  window.Shopify = {};
}

/**
 * Binds a function to a scope.
 * @param {Function} fn - The function to bind.
 * @param {Object} scope - The scope to bind the function to.
 * @returns {any} - The bound function.
 */
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

/**
 * Sets the selected option in a selector element by its value or innerHTML.
 * @param {HTMLSelectElement} selector - The selector element.
 * @param {string} value - The value to match.
 * @returns {number | undefined} - The index of the selected option.
 */
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

/**
 * Adds an event listener to a target element.
 * @param {EventTarget} target - The target element.
 * @param {string} eventName - The name of the event.
 * @param {EventListenerOrEventListenerObject} callback - The callback function to execute when the event is triggered.
 */
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : // @ts-ignore - IE8 compatibility
      target.attachEvent('on' + eventName, callback);
};

/**
 * Submits a form by creating and submitting a hidden form element.
 * @param {string} path - The action path for the form.
 * @param {Object} [options] - The options for the form submission.
 * @param {string} [options.method='post'] - The HTTP method for the form submission.
 * @param {Object} [options.parameters={}] - The parameters to include in the form submission.
 */
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  /**
   * @type {Object<any, string>}
   */
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

/**
 * Creates a new CountryProvinceSelector.
 * @class
 * @param {string} country_domid - The ID of the country selector element.
 * @param {string} province_domid - The ID of the province selector element.
 * @param {Object} options - The options for the CountryProvinceSelector.
 * @param {string} [options.hideElement] - The ID of the element to hide when there are no provinces.
 */
Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  /**
   * @type {HTMLElement | HTMLSelectElement | null}
   */
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  if (!this.countryEl) return;

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    if (!this.countryEl || !(this.countryEl instanceof HTMLSelectElement)) return;
    var value = this.countryEl.getAttribute('data-default');
    if (!value) return;
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    if (!this.provinceEl || !(this.provinceEl instanceof HTMLSelectElement)) return;
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function () {
    if (!this.countryEl || !(this.countryEl instanceof HTMLSelectElement)) return;
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    if (!raw) return;
    var provinces = JSON.parse(raw);

    if (!this.provinceEl || !(this.provinceEl instanceof HTMLSelectElement)) return;
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      if (this.provinceContainer) {
        this.provinceContainer.style.display = 'none';
      }
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      if (this.provinceContainer) {
        this.provinceContainer.style.display = '';
      }
    }
  },

  /**
   * Clears all options from a selector element.
   * @param {HTMLSelectElement} selector - The selector element.
   */
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  /**
   * Sets the options of a selector element.
   * @param {HTMLSelectElement} selector - The selector element.
   * @param {Array<any>} values - The values to set as options.
   */
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/**
 * Init modal triggers
 * @param {String} key - The key to fetch the modal content.
 */
function initModalTriggers(key) {
  const triggers = document.querySelectorAll(`[js-${key}-trigger]`);

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      trigger?.hasAttribute(`js-${key}-loaded`) ? openModal(key) : fetchModalContent(trigger, key);
    });
  });
}

/**
 *
 * @param {String} key - The trigger element.
 */
export function openModal(key) {
  document.dispatchEvent(
    new CustomEvent('openModal', {
      bubbles: true,
      detail: {
        key: key,
      },
    }),
  );
}

document.addEventListener('DOMContentLoaded', () => {
  initModalTriggers('speculator');
  initModalTriggers('store-appointment');
  initModalTriggers('product-wizard');
  handleDeviceChange();
});
